import { EnvironmentProviders, Provider } from '@angular/core';
import { provideRxChildStore } from '@noda-lib/utils/stores';

import { MARKETPLACE_STORE, MarketplaceStore } from '../marketplace.store';

export function provideChildStore(): (EnvironmentProviders | Provider)[] {
  return [provideRxChildStore(MARKETPLACE_STORE, MarketplaceStore)];
}
